import sopClassDictionary from '../util/sopClassDictionary';

/**
 * Checks whether dicom files with specified SOP Class UID have image data
 * @param {string} SOPClassUID - SOP Class UID to be checked
 * @returns {boolean} - true if it has image data
 */

export default function isWaveform(SOPClassUID) {
  return SOPClassUID === sopClassDictionary.Sop12LeadECGWaveformStorage
      || SOPClassUID === sopClassDictionary.GeneralECGWaveformStorage
      || SOPClassUID === sopClassDictionary.AmbulatoryECGWaveformStorage
      || SOPClassUID === sopClassDictionary.HemodynamicWaveformStorage
      || SOPClassUID === sopClassDictionary.CardiacElectrophysiologyWaveformStorage
      || SOPClassUID === sopClassDictionary.GeneralAudioWaveformStorage
      || SOPClassUID === sopClassDictionary.ArterialPulseWaveformStorage
      || SOPClassUID === sopClassDictionary.RespiratoryWaveformStorage;
}
